import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { SkeletonList } from '../components/ui/Skeleton';
import { PageShell } from '../components/ui/PageShell';
import { Project } from '../types';
import { getProject } from '../services/projectService';
import ChecklistComponent from '../components/ChecklistComponent';

const ChecklistPage: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();

  const [project, setProject] = useState<Project | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchProject = async () => {
      if (!projectId) return;

      try {
        setLoading(true);
        const fetchedProject = await getProject(projectId);
        setProject(fetchedProject);
        setError(null);
      } catch (err) {
        console.error('Error fetching project:', err);
        setError('Kunde inte hämta projektet. Försök igen senare.');
      } finally {
        setLoading(false);
      }
    };

    fetchProject();
  }, [projectId]);

  const backLink = projectId ? `/projects/${projectId}` : '/';

  if (loading) {
    return (
      <PageShell title="Checklistor" backTo={backLink} backLabel="Projekt">
        <div className="space-y-4 py-2">
          <SkeletonList count={3} />
        </div>
      </PageShell>
    );
  }

  if (error || !project) {
    return (
      <PageShell title="Checklistor" backTo={backLink} backLabel="Projekt">
        <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800/40 text-red-700 dark:text-red-400 px-4 py-3 rounded-xl text-sm mt-4">
          {error || 'Projektet kunde inte hittas.'}
        </div>
      </PageShell>
    );
  }

  return (
    <PageShell title="Checklistor" backTo={backLink} backLabel="Projekt">
      <div className="pb-24">
        {projectId && <ChecklistComponent projectId={projectId} />}
      </div>
    </PageShell>
  );
};

export default ChecklistPage;
